import * as React from "react";

function PencilIcon(props) {
	return (
		<svg
			viewBox="0 0 16 16"
			fill="currentColor"
			height="1em"
			width="1em"
			{...props}
		>
			<path
				fill="currentColor"
				d="M13.5 0a2.5 2.5 0 012 4l-1 1L11 1.5l1-1c.418-.314.937-.5 1.5-.5zM1 11.5L0 16l4.5-1 9.25-9.25-3.5-3.5L1 11.5zm10.181-5.819l-7 7-.862-.862 7-7 .862.862z"
			/>
		</svg>
	);
}

export default React.memo(PencilIcon);
